import { SvgIcon } from '@admin/shared/components/icons/svg-icon';
import type { SvgIconComponentProps } from '@admin/shared/components/icons/svg-icon';
import { Themes, useThemeName } from '@admin/shared/themes/themes';
import { AttentionIcon } from '@admin/shared/components/icons/custom/attention';

/**
 * Lock Icon.
 * (used in login components)
 *
 * @param {SvgIconComponentProps} props - svg component props.
 *
 * @returns {JSX.Element}
 */
export const LockIcon = (props: SvgIconComponentProps): JSX.Element => {
  const name = useThemeName();

  if (name === Themes.USERLIKE) {
    return <AttentionIcon {...props} />;
  }

  return (
    <SvgIcon name="OMQLockIcon" {...props} viewBox="0 0 56 56">
      <path
        d="M42 18.667h-2.333V14C39.667 7.56 34.44 2.333 28 2.333 21.56 2.333 16.333 7.56 16.333 14v4.667H14a4.68 4.68 0 0 0-4.667 4.666v23.334A4.68 4.68 0 0 0 14 51.333h28a4.68 4.68 0 0 0 4.667-4.666V23.333A4.68 4.68 0 0 0 42 18.667zm-14 21A4.68 4.68 0 0 1 23.333 35 4.68 4.68 0 0 1 28 30.333 4.68 4.68 0 0 1 32.667 35 4.68 4.68 0 0 1 28 39.667zm7.233-21H20.767V14A7.24 7.24 0 0 1 28 6.767 7.24 7.24 0 0 1 35.233 14v4.667z"
        fill="currentColor"
      />
    </SvgIcon>
  );
};
